module.exports = {
          srcSet: "/_next/static/images/img-vetements@2x-160-fc55ecafb3ccbbfbf8d40aa70c7d6204.webp"+" 160w"+","+"/_next/static/images/img-vetements@2x-292-049c260710f9579f42b13696c71f6c9e.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-vetements@2x-160-fc55ecafb3ccbbfbf8d40aa70c7d6204.webp",width: 160,height: 137},{path: "/_next/static/images/img-vetements@2x-292-049c260710f9579f42b13696c71f6c9e.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-vetements@2x-160-fc55ecafb3ccbbfbf8d40aa70c7d6204.webp",
          toString:function(){return "/_next/static/images/img-vetements@2x-160-fc55ecafb3ccbbfbf8d40aa70c7d6204.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }